import {ReactElement} from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import {PromotionOffer} from './types'
import {
  PROMOTION_RULES_MODAL_SUBTITLE,
  PROMOTION_RULES_MODAL_TITLE,
  promotionRulesTableRows,
} from './promotionOpenHelpers'
import './tenx-promotion.css'

type Props = {
  open: boolean
  onClose: () => void
  offers: PromotionOffer[]
}

export function PromotionRulesDialog({open, onClose, offers}: Props): ReactElement {
  const rows = promotionRulesTableRows(offers)
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth data-testid="pm-rules-dialog">
      <DialogTitle disableTypography>
        <Typography variant="h6" component="h2">
          {PROMOTION_RULES_MODAL_TITLE}
        </Typography>
        <IconButton aria-label="Close" onClick={onClose} style={{position: 'absolute', right: 8, top: 8}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography color="textSecondary" paragraph>
          {PROMOTION_RULES_MODAL_SUBTITLE}
        </Typography>
        <div className="pm-rules-table-wrap">
          <table className="pm-rules-table" data-testid="pm-rules-table">
            <thead>
              <tr>
                <th>Factor</th>
                <th>Drawdown</th>
                <th>Profit split (you / Tauro)</th>
                <th>Leverage</th>
                <th>Deposit (USD)</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.multiplier}>
                  <td>
                    <span className="pm-factor-badge">{row.multiplier}x</span>
                  </td>
                  <td>{row.drawdownTriggerPercent}%</td>
                  <td>
                    {row.clientProfitSplitPercent} / {row.tauroProfitSplitPercent}
                  </td>
                  <td>1:{row.leverage}</td>
                  <td>
                    {row.minQualifyingDeposit.toLocaleString()} to {row.maxQualifyingDeposit.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </DialogContent>
      <DialogActions>
        <Button className="pm-btn pm-btn--blue" variant="contained" disableElevation onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
